export default __webpack_public_path__ + "static/media/jpg-file.5b5c8107.svg";